export default __webpack_public_path__ + "static/media/bacon.69527153.svg";